<template>
  <portal to="app-header" :order="2">
    <div :class="`app-header-wrapper ${vFooterClass}`">
      <slot></slot>
    </div>
  </portal>
</template>

<script>
import {maxErrorLevel} from "@/components/molecules/ErrorMessage";

export default {
  name: "AppHeader",
  inject: ['mainPadding'],
  props: {
    errors: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    vFooterClass() {
      return 'el-' + maxErrorLevel(this.errors);
    },
  },
}
</script>

<style lang="scss" scoped>
@use "sass:math";
@use "../../utils/blend-modes";

/**
 * テーマカラーから半透明の背景色を生成します
 *
 * @param $color テーマカラー
 */
@function bg-color($color) {
  $hsv: blend-modes.color-to-hsv($color);
  $result-hsv: nth($hsv, 1), math.max(1, nth($hsv, 2) * 1.3), nth($hsv, 3);
  $result-rgb: blend-modes.hsv-to-color($result-hsv);
  @return rgba(red($result-rgb), green($result-rgb), blue($result-rgb), 0.7);
}

/**
 * テーマカラーからボーダー色を生成します
 *
 * @param $color テーマカラー
 */
@function border-color($color) {
  $hsv: blend-modes.color-to-hsv($color);
  $result-hsv: nth($hsv, 1), percentage(0.9), percentage(0.3);
  @return blend-modes.hsv-to-color($result-hsv);
}

/**
 * エラーレベルとテーマカラーからルールを生成します
 *
 * @param $level エラーレベル
 * @param $color テーマカラー
 */
@mixin el-color($level, $color) {
  &.el-#{$level} {
    background-color: bg-color($color);
    border: 1px solid border-color($color);
  }
}

.app-header-wrapper {
  display: flex;
  padding: 0.5rem;
  margin: 0.5rem;
  border-radius: 3px;

  @include el-color('error', #ffe6e6);
  @include el-color('warn', #fff2d9);
  @include el-color('info', #e6ecff);
  @include el-color('good', #e6ffe7);
}
</style>
